import { useState } from "react";
import { useContract } from "./useContract";

interface PrintIProps {
  contractId: number;
  dealerId: number;
  requisitesId: number;
  contractNumber: string;
}

export interface UsePrintTemplateResult {
  isLoading: boolean;
  error: string | null;
  print: ({
    contractId,
    dealerId,
    requisitesId,
    contractNumber,
  }: PrintIProps) => Promise<void>;
}
export const usePrintTemplate = (): UsePrintTemplateResult => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { printTemplate } = useContract();

  const print = async ({
    contractId,
    dealerId,
    requisitesId,
    contractNumber,
  }: PrintIProps) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await printTemplate({
        contractId,
        dealerId,
        requisitesId,
      });

      if (!response.data) {
        setError("Ошибка загрузки");
      }

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      const url = window.URL.createObjectURL(blob);

      const filename = `${contractNumber}.docx`;

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      setError("Ошибка загрузки");
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, print };
};
